import { type GatsbyBrowser } from 'gatsby';
import React from 'react';
import Layout from './src/components/layout/layout';
import './src/styles/global.css';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => <Layout>{element}</Layout>;
